var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"editForm"}},[_c('pack-info',{attrs:{"packId":_vm.packId}}),_c('v-container',{attrs:{"fluid":""}},[_c('v-row',{staticClass:"och-topMargin--packInfoOffset",attrs:{"justify-center":""}},[_c('v-col',{attrs:{"sm":"12","md":"11"}},[_c('release-note-form',{attrs:{"mode":"edit"}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }